/**
 * Copy text to clipboard with HTTP fallback
 * Works on both HTTPS and HTTP environments
 */
export async function copyToClipboard(text) {
  // Try modern Clipboard API first (HTTPS only)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.log('Clipboard API failed, using fallback');
    }
  }

  // Fallback for HTTP or if Clipboard API fails
  try {
    // Create temporary textarea
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-999999px';
    textarea.style.top = '-999999px';
    document.body.appendChild(textarea);

    // Select and copy
    textarea.focus();
    textarea.select();

    // For mobile Safari
    textarea.setSelectionRange(0, 99999);

    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);

    return successful;
  } catch (err) {
    console.error('Copy failed:', err);
    return false;
  }
}

/**
 * Share content with native share API or fallback to copy
 * Works on both HTTPS and HTTP environments
 */
export async function shareContent({ title, text, url }) {
  // Try native share API first (mobile)
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return { success: true, method: 'share' };
    } catch (err) {
      // User cancelled or error occurred
      if (err.name === 'AbortError') {
        return { success: false, cancelled: true };
      }
      console.log('Share API failed, using fallback');
    }
  }

  // Fallback: copy URL to clipboard
  const copied = await copyToClipboard(url || text);
  return { success: copied, method: 'copy' };
}
